var area = [{
	"value": "310000",
	"label": "上海市",
	"children": [{
		"value": "310100",
		"label": "市辖区",
		"children": [{
			"value": "310101",
			"label": "黄浦区"
		}, {
			"value": "310104",
			"label": "徐汇区"
		}, {
			"value": "310105",
			"label": "长宁区"
		}, {
			"value": "310106",
			"label": "静安区"
		}, {
			"value": "310107",
			"label": "普陀区"
		}, {
			"value": "310109",
			"label": "虹口区"
		}, {
			"value": "310110",
			"label": "杨浦区"
		}, {
			"value": "310112",
			"label": "闵行区"
		}, {
			"value": "310113",
			"label": "宝山区"
		}, {
			"value": "310114",
			"label": "嘉定区"
		}, {
			"value": "310115",
			"label": "浦东新区"
		}, {
			"value": "310116",
			"label": "金山区"
		}, {
			"value": "310117",
			"label": "松江区"
		}, {
			"value": "310118",
			"label": "青浦区"
		}, {
			"value": "310120",
			"label": "奉贤区"
		}, {
			"value": "310151",
			"label": "崇明区"
		}]
	}]
}, {
	"value": "330000",
	"label": "浙江省",
	"children": [{
		"value": "330400",
		"label": "嘉兴市",
		"children": [{
			"value": "330424",
			"label": "海盐县"
		}]
	}]
}];

export default {
    area,
};